export { default } from './ScoredJourneyRoute'
